import {
  PreviewWrapper,
  HeaderSection,
  HeadingContainer,
  HeadingTitle,
  ContentBody,
  ScanBottomSection,
  NotFoundErrorText,
  NotFoundDescription,
  NotFoundContentBox,
} from "../share/styled"
import { useLogMealStep } from "features/meal/hooks"

import Button from "components/Buttons/Button"
import Header from "../share/Header"
import ScanFailedPhoto from "../share/ScanFailedPhoto"
import ScanFailedBottomActions from "../share/ScanFailedBottomActions"

const ScanFailed = () => {
  const setStep = useLogMealStep()

  const handleRetakePhoto = () => {
    setStep("take-photo")
  }

  return (
    <PreviewWrapper>
      <Header />

      {/* Header with Title */}
      <HeaderSection>
        <HeadingContainer>
          <HeadingTitle>Photo Uploaded</HeadingTitle>
        </HeadingContainer>
      </HeaderSection>

      {/* Content Body */}
      <ContentBody>
        <ScanBottomSection>
          <ScanFailedPhoto />

          <NotFoundContentBox>
            <NotFoundErrorText>Something went wrong.</NotFoundErrorText>
            <NotFoundDescription>Let’s try again.</NotFoundDescription>

            <Button
              $borderLess
              style={{ width: 143, alignSelf: "center", marginTop: 16 }}
              onClick={handleRetakePhoto}
              $type="primary"
            >
              Retry
            </Button>
          </NotFoundContentBox>
        </ScanBottomSection>
      </ContentBody>
    </PreviewWrapper>
  )
}

export default ScanFailed
